import {html} from "./utils/environment";

import productsCategoriesList from "./components/products-categories-list";

window.onload = () => {
    init();
};

function init() {
    console.log("App JS Started");

    html.classList.add("is-loaded");
    html.classList.add("is-ready");
    html.classList.remove("is-loading");

    productsCategoriesList();
}
